import * as React from 'react';

const classNames = require('classnames');

interface IProps {
  className?: string;
  text: string;
  disabledText?: string;
  isFull?: boolean;
  hasError?: boolean;
  id?: string;
  isCompact?: boolean;
  isDisabled?: boolean;
  isSubmitting?: boolean;
  submittingText?: string;
  successText?: string;
  type?: 'success' | 'error' | 'info' | 'warning' | 'error-outline';
  handleClick?(): void;
}

interface IState {
  disabledText: string;
  isProvidingFeedback: boolean;
  submittingText: string;
}

class Button extends React.Component<IProps, IState> {
  public static defaultProps: Partial<IProps> = {
    hasError: false,
    isCompact: false,
    isDisabled: false,
    isFull: false,
    isSubmitting: false,
    type: 'info',
  };

  constructor(props: IProps) {
    super(props);
    this.state = {
      disabledText: props.disabledText || props.text,
      isProvidingFeedback: false,
      submittingText: props.submittingText || props.text,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleProvidingFeedback = this.handleProvidingFeedback.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.props.successText) {
      return;
    }

    if (prevProps.isSubmitting && !this.props.isSubmitting) {
      this.setState({ isProvidingFeedback: true }, () => {
        this.handleProvidingFeedback();
      });
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  handleProvidingFeedback() {
    return setTimeout(() => this.setState({ isProvidingFeedback: false }), 1500);
  }

  handleClick() {
    if (this.props.handleClick) {
      this.props.handleClick();
    }
  }

  renderText() {
    if (this.state.isProvidingFeedback && this.props.successText && !this.props.hasError) {
      return (
        <React.Fragment>
          {this.props.successText}
          <i className="fa fa-check mar-l-1 animated animate__fadeIn" />
        </React.Fragment>
      );
    }
    if (this.props.isDisabled) {
      return this.state.disabledText;
    }
    if (this.props.isSubmitting) {
      return this.state.submittingText;
    }
    return this.props.text;
  }

  // NOTE: (TomLuce) Unhappy that i just bundled in a classname override here - future consideration is to make it
  // work properly for all the different classes that we might want to put on a button
  buttonClasses() {
    if (this.props.className) {
      return this.props.className;
    }

    return classNames(
      'button',
      `button--${this.props.type}`,
      { 'button--compact': this.props.isCompact },
      { 'button--full': this.props.isFull },
    );
  }

  render() {
    return (
      <button
        id={this.props.id}
        disabled={this.props.isDisabled || this.props.isSubmitting || this.state.isProvidingFeedback}
        className={this.buttonClasses()}
        onClick={this.handleClick}
      >
        {this.renderText()}
      </button>
    );
  }
}

export default Button;
